import src from "./brands-desktop.png";
export default { src: src, aspect: 38.7241, width: 2246, height: 58 };